import { FaFire } from "react-icons/fa6";
import { Link } from "react-router-dom";
import TopMenu from "../top-menu/TopMenu";
import BottomMenu from "../bottom-menu/BottomMenu";
import ReferralSystem from "../referral-system/ReferralSystem";
import TestPreview from "../test/TestPreview";
import {
  getCurrentWeekMood,
  getDayStreak,
  checkRecapAvailability,
} from "../../api/mainApi";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Advertisement from "../advertisement/Advertisement";
import News from "../news/News";
import MeditationList from "../meditation/MeditationList";

function Main() {
  const { t } = useTranslation();

  // 1. ЛОГІКА: Безпечна ініціалізація стріку
  const [dayStreak, setdayStreak] = useState(() => {
    const saved = localStorage.getItem("dayStreak");
    // Якщо збережено "0", це має бути число 0, а не null
    return saved !== null && saved !== "undefined" ? Number(saved) : null;
  });

  const premium = localStorage.getItem("premium");
  const isPremium =
    premium === "true" || (!isNaN(premium) && Number(premium) > 0);

  const [moods, setMoods] = useState([]);
  // const [hasRecap, setHasRecap] = useState(false);

  // Стан для відкриття списку настроїв
  const [selectedDayIndex, setSelectedDayIndex] = useState(null);

  const weekDays = [
    t("mon"),
    t("tue"),
    t("wed"),
    t("thu"),
    t("fri"),
    t("sat"),
    t("sun"),
  ];

  useEffect(() => {
    const fetchData = async () => {
      try {
        // --- ОТРИМАННЯ STREAK ---
        const streakData = await getDayStreak();

        // Перевіряємо: якщо API повернуло 0, використовуємо 0.
        // Оператор ?? (nullish coalescing) використає 0, якщо зліва null або undefined.
        const streakValue = streakData?.day_streak ?? 0;

        setdayStreak(streakValue);
        localStorage.setItem("dayStreak", streakValue);

        // --- ІНШІ ДАНІ ---
        const moodData = await getCurrentWeekMood();
        setMoods(moodData.weekly_moods || []);

        // const recapCheck = await checkRecapAvailability(tg.initData, 2025);
        // setHasRecap(recapCheck.data.available);
      } catch (error) {
        console.error("Error fetching main data:", error);
      }
    };

    fetchData();
  }, []);

  const getDayOfWeek = (date) => {
    const day = new Date(date * 1000);
    return day.getDay() === 0 ? 6 : day.getDay() - 1;
  };

  const getMoodImage = (mood, additionalMood = null) => {
    if (mood >= 1 && mood <= 5) {
      if (additionalMood && additionalMood >= 1 && additionalMood <= 3) {
        return `/${mood}.${additionalMood}.webp`;
      }
      return `/${mood}.webp`;
    }
    return "/0.webp";
  };

  const handleDayClick = (index, hasMultipleMoods) => {
    if (hasMultipleMoods) {
      setSelectedDayIndex(selectedDayIndex === index ? null : index);
    }
  };

  return (
    <div className="h-dvh flex flex-col relative">
      {/* 2. ЛОГІКА: Прозора підкладка для закриття меню при кліку поза ним */}
      {selectedDayIndex !== null && (
        <div
          className="fixed inset-0 z-40 bg-transparent"
          onClick={() => setSelectedDayIndex(null)}
        />
      )}

      <TopMenu />

<div className="flex-1 flex flex-col gap-y-4 pb-2 overflow-y-auto overflow-x-hidden hidden-scrollbar lg:custom-scrollbar -mx-4 px-4">
        {/* КАЛЕНДАР */}
        <div className="rounded-lg py-2">
          <div className="flex justify-between font-bold mb-2">
            <p>{t("calendar")}</p>
            <Link
              to={"statistics"}
              className="bg-gray-800 px-3 text-sm font-semibold rounded-full flex items-center"
            >
              {t("showFull")}
            </Link>
          </div>

          <div className="grid grid-cols-7 text-sm">
            {Array.from({ length: 7 }, (_, index) => {
              const startOfWeek = new Date();
              const currentDayOfWeek = startOfWeek.getDay();
              const startOffset =
                currentDayOfWeek === 0 ? -6 : 1 - currentDayOfWeek;
              startOfWeek.setDate(startOfWeek.getDate() + startOffset + index);

              const dayMoods = moods.filter(
                (mood) => getDayOfWeek(mood.date) === index
              );
              const latestMood =
                dayMoods.length > 0 ? dayMoods[dayMoods.length - 1] : null;
              const isToday =
                new Date().toDateString() === startOfWeek.toDateString();
              const hasMultipleMoods = dayMoods.length > 1;
              const isSelected = selectedDayIndex === index;

              return (
                <div
                  key={index}
                  onClick={() => handleDayClick(index, hasMultipleMoods)}
                  // z-50 піднімає елемент над підкладкою, якщо він активний
                  className={`p-2 relative transition-all ${
                    isSelected ? "z-50" : "z-0"
                  } ${
                    isToday
                      ? "rounded-full bg-gradient-to-b from-emerald-500 to-cyan-500 drop-shadow-lg"
                      : ""
                  } ${
                    hasMultipleMoods
                      ? "cursor-pointer hover:bg-white/10 rounded-lg"
                      : ""
                  }`}
                >
                  <p className="text-xl font-bold">{startOfWeek.getDate()}</p>

                  <div className="relative inline-block">
                    <img
                      src={
                        latestMood
                          ? getMoodImage(
                              latestMood.mood,
                              latestMood.additional_mood
                            )
                          : isToday
                          ? "/0.webp"
                          : "/0.1.webp"
                      }
                      className="mx-auto"
                      alt={t("moodAlt")}
                    />
                    {hasMultipleMoods && (
                      <div className="absolute -bottom-1 -right-1 bg-white text-black text-[10px] rounded-full w-4 h-4 flex items-center justify-center font-bold shadow-sm">
                        +
                      </div>
                    )}
                  </div>

                  <p>{weekDays[index]}</p>

                  {/* Випадаючий список */}
                  {isSelected && hasMultipleMoods && (
                    <div className="absolute top-full left-1/2 -translate-x-1/2 mt-1 z-50 bg-gray-800 border border-gray-700 rounded-lg p-2 shadow-xl flex flex-col gap-2 min-w-[50px]">
                      {dayMoods.map((moodItem, i) => (
                        <div
                          key={i}
                          className="flex justify-center border-b border-white/10 last:border-0 pb-1 last:pb-0"
                        >
                          <img
                            src={getMoodImage(
                              moodItem.mood,
                              moodItem.additional_mood
                            )}
                            className="w-8 h-8 object-contain"
                            alt="history"
                          />
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>

        {/* Блок Streak */}
        <div className="flex flex-col rounded-xl bg-gradient-to-tr from-emerald-500 via-cyan-500 to-emerald-500 bg-gradient-size animate-gradient-move shadow-lg">
          <div className="flex items-center p-4 gap-4">
            <div className="bg-white/20 p-3 rounded-full shadow-inner">
              <FaFire className="w-8 h-8 text-white drop-shadow" />
            </div>
            <div>
              <p className="text-xs text-white/70 uppercase font-bold tracking-wider mb-0.5">
                {t("dayStrike")}
              </p>

              {/* Відображаємо значення, якщо воно є числом (включаючи 0) */}
              {dayStreak !== null ? (
                <p className="text-4xl font-black leading-none">{dayStreak}</p>
              ) : (
                <div className="w-12 h-8 bg-white/20 rounded animate-pulse" />
              )}
            </div>
          </div>

          <Link
            to="mood-menu"
            className="bg-black/10 hover:bg-black/20 p-3 text-center text-sm font-bold uppercase tracking-wide transition-colors flex items-center justify-center gap-2 border-t border-white/10"
          >
            <span>{t("markTheMood")}</span>
          </Link>
        </div>

        {!isPremium ? (
          <div className="flex flex-col items-center gap-4">
            <Advertisement />
          </div>
        ) : (
          <></>
        )}
        <MeditationList />
        <TestPreview />
      </div>
      <BottomMenu />
    </div>
  );
}

export default Main;
